import CityPageToldos from "../components/CityPageToldos";

export default function ToldosVelezMalaga() {
  return (
    <CityPageToldos
      name="Vélez-Málaga"
      slug="velez-malaga"
      cp="29700"
      poblacion={87798}
      zonaGeo="Axarquía"
      lat={36.7798}
      lng={-4.1027}
      zonas={["Torre del Mar", "Vélez Centro", "Caleta de Vélez", "Almayate"]}
      landmarks={["Torre del Mar", "Fortaleza de Vélez", "Caleta Puerto"]}
      municipiosLimitrofes={["Algarrobo", "Torrox", "Benamargosa"]}
      festivalLocal="Real Feria de San Miguel, finales de septiembre"
      contextoTipologico="Capital de la Axarquía, Torre del Mar zona residencial moderna con áticos y chalets, demanda creciente de toldos para terrazas costeras."
      isCoreZone={false}
    />
  );
}